import React, { useState } from 'react';

interface ImageWithLoaderProps {
  src: string;
  alt: string;
  style?: React.CSSProperties;
}

const ImageWithLoader: React.FC<ImageWithLoaderProps> = ({
  src,
  alt,
  style,
}) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const handleLoad = () => {
    setLoading(false);
  };

  const handleError = () => {
    setLoading(false);
    setError(true);
  };

  return (
    <div>
      {loading && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '200px',
            position: 'relative',
          }}
        >
          <div
            className="skeleton"
            aria-hidden="true"
            style={{ width: '100%', height: '200px' }}
          />
        </div>
      )}

      {error ? (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '200px',
            backgroundColor: '#f5f5f5',
            borderRadius: '4px',
          }}
        >
          <p>Failed to load image</p>
        </div>
      ) : (
        <img
          alt={alt}
          src={src}
          style={{
            ...style,
            display: loading ? 'none' : 'block',
          }}
          onLoad={handleLoad}
          onError={handleError}
        />
      )}
    </div>
  );
};

export { ImageWithLoader };
